let protooPort = 4443

export function getProtooUrl({ roomId, peerId, forceH264, forceVP9 }) {
  const hostname = 'media-provider.holacon.com' // window.location.hostname
  let url = `wss://${hostname}:${protooPort}/?roomId=${roomId}&peerId=${peerId}`

  // if (forceH264) url = `${url}&forceH264=true`
  // else if (forceVP9) url = `${url}&forceVP9=true`

  return url
}



//////////////////
// WEBPACK FOOTER
// ./utils/urlFactory.js
// module id = null
// module chunks = 